// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "decco/src/Decco.bs.js";
import * as Js_exn from "rescript/lib/es6/js_exn.js";
import * as $$String from "rescript/lib/es6/string.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Js_json from "rescript/lib/es6/js_json.js";
import * as Js_array from "rescript/lib/es6/js_array.js";
import * as Js_string from "rescript/lib/es6/js_string.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Pervasives from "rescript/lib/es6/pervasives.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Caml_js_exceptions from "rescript/lib/es6/caml_js_exceptions.js";

function sourcePosition_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var filename = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "filename"), null));
  if (filename.TAG === /* Ok */0) {
    var start_line = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "start_line"), null));
    if (start_line.TAG === /* Ok */0) {
      var end_line = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "end_line"), null));
      if (end_line.TAG === /* Ok */0) {
        var start_column = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "start_column"), null));
        if (start_column.TAG === /* Ok */0) {
          var end_column = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "end_column"), null));
          if (end_column.TAG === /* Ok */0) {
            var law_headings = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "law_headings"), null));
            if (law_headings.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        filename: filename._0,
                        start_line: start_line._0,
                        end_line: end_line._0,
                        start_column: start_column._0,
                        end_column: end_column._0,
                        law_headings: law_headings._0
                      }
                    };
            }
            var e = law_headings._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".law_headings" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = end_column._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".end_column" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
        }
        var e$2 = start_column._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".start_column" + e$2.path,
                  message: e$2.message,
                  value: e$2.value
                }
              };
      }
      var e$3 = end_line._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".end_line" + e$3.path,
                message: e$3.message,
                value: e$3.value
              }
            };
    }
    var e$4 = start_line._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".start_line" + e$4.path,
              message: e$4.message,
              value: e$4.value
            }
          };
  }
  var e$5 = filename._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".filename" + e$5.path,
            message: e$5.message,
            value: e$5.value
          }
        };
}

function t_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = Js_array.map(Js_json.classify, jsonArr$1);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Array" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.arrayFromJson(t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Array */8,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "Bool" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Decco.boolFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Bool */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "Date" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Date */4,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "Decimal" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = Decco.floatFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Decimal */3,
                      _0: v0$3._0
                    }
                  };
          }
          var e$3 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "Duration" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$4 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$4.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Duration */5,
                      _0: v0$4._0
                    }
                  };
          }
          var e$4 = v0$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      case "Enum" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Decco.listFromJson(Decco.stringFromJson, Belt_Array.getExn(jsonArr$1, 1));
          var json = Belt_Array.getExn(jsonArr$1, 2);
          var match$2 = Js_json.classify(json);
          var match$3;
          if (typeof match$2 === "number" || match$2.TAG !== /* JSONArray */3) {
            match$3 = Decco.error(undefined, "Not a tuple", json);
          } else {
            var match$4 = match$2._0;
            if (match$4.length !== 2) {
              match$3 = Decco.error(undefined, "Incorrect cardinality", json);
            } else {
              var v0$5 = match$4[0];
              var v1 = match$4[1];
              var match$5 = Decco.stringFromJson(v0$5);
              var match$6 = t_decode(v1);
              if (match$5.TAG === /* Ok */0) {
                if (match$6.TAG === /* Ok */0) {
                  match$3 = {
                    TAG: /* Ok */0,
                    _0: [
                      match$5._0,
                      match$6._0
                    ]
                  };
                } else {
                  var e$5 = match$6._0;
                  match$3 = {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$5.path,
                      message: e$5.message,
                      value: e$5.value
                    }
                  };
                }
              } else {
                var e$6 = match$5._0;
                match$3 = {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
              }
            }
          }
          if (match$1.TAG === /* Ok */0) {
            if (match$3.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* Enum */6,
                        _0: match$1._0,
                        _1: match$3._0
                      }
                    };
            }
            var e$7 = match$3._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$7.path,
                      message: e$7.message,
                      value: e$7.value
                    }
                  };
          }
          var e$8 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$8.path,
                    message: e$8.message,
                    value: e$8.value
                  }
                };
      case "Integer" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$6 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$6.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Integer */1,
                      _0: v0$6._0
                    }
                  };
          }
          var e$9 = v0$6._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$9.path,
                    message: e$9.message,
                    value: e$9.value
                  }
                };
      case "Money" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$7 = Decco.floatFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$7.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Money */2,
                      _0: v0$7._0
                    }
                  };
          }
          var e$10 = v0$7._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$10.path,
                    message: e$10.message,
                    value: e$10.value
                  }
                };
      case "Struct" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$7 = Decco.listFromJson(Decco.stringFromJson, Belt_Array.getExn(jsonArr$1, 1));
          var match$8 = Decco.listFromJson((function (json) {
                  var match = Js_json.classify(json);
                  if (typeof match === "number") {
                    return Decco.error(undefined, "Not a tuple", json);
                  }
                  if (match.TAG !== /* JSONArray */3) {
                    return Decco.error(undefined, "Not a tuple", json);
                  }
                  var match$1 = match._0;
                  if (match$1.length !== 2) {
                    return Decco.error(undefined, "Incorrect cardinality", json);
                  }
                  var v0 = match$1[0];
                  var v1 = match$1[1];
                  var match$2 = Decco.stringFromJson(v0);
                  var match$3 = t_decode(v1);
                  if (match$2.TAG === /* Ok */0) {
                    if (match$3.TAG === /* Ok */0) {
                      return {
                              TAG: /* Ok */0,
                              _0: [
                                match$2._0,
                                match$3._0
                              ]
                            };
                    }
                    var e = match$3._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: "[1]" + e.path,
                              message: e.message,
                              value: e.value
                            }
                          };
                  }
                  var e$1 = match$2._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: "[0]" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                          }
                        };
                }), Belt_Array.getExn(jsonArr$1, 2));
          if (match$7.TAG === /* Ok */0) {
            if (match$8.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* Struct */7,
                        _0: match$7._0,
                        _1: match$8._0
                      }
                    };
            }
            var e$11 = match$8._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$11.path,
                      message: e$11.message,
                      value: e$11.value
                    }
                  };
          }
          var e$12 = match$7._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$12.path,
                    message: e$12.message,
                    value: e$12.value
                  }
                };
      case "Unembeddable" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Unembeddable */1
                  };
          }
      case "Unit" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Unit */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function loggedValueToString(val, tab) {
  var tmp;
  if (typeof val === "number") {
    tmp = val === /* Unit */0 ? "Unit" : "Other";
  } else {
    switch (val.TAG | 0) {
      case /* Bool */0 :
          tmp = "Bool: " + Pervasives.string_of_bool(val._0);
          break;
      case /* Integer */1 :
          tmp = "Integer: " + String(val._0);
          break;
      case /* Money */2 :
          tmp = "Money: " + val._0.toString();
          break;
      case /* Decimal */3 :
          tmp = "Decimal: " + val._0.toString();
          break;
      case /* Date */4 :
          tmp = "Date: " + val._0;
          break;
      case /* Duration */5 :
          tmp = "Duration: " + val._0;
          break;
      case /* Enum */6 :
          var match = val._1;
          tmp = "Enum[" + $$String.concat(",", val._0) + "]:" + match[0] + "\n" + loggedValueToString(match[1], tab + 1 | 0);
          break;
      default:
        tmp = "Other";
    }
  }
  return Js_string.repeat(tab, "\t") + tmp;
}

var LoggedValue = {
  t_decode: t_decode,
  loggedValueToString: loggedValueToString
};

function eventTypeFromString(str) {
  switch (str) {
    case "Begin call" :
        return /* BeginCall */0;
    case "Decision taken" :
        return /* DecisionTaken */3;
    case "End call" :
        return /* EndCall */1;
    case "Variable definition" :
        return /* VariableDefinition */2;
    default:
      return Js_exn.raiseError("Unknown event type: " + str + "");
  }
}

function deserializedEvents(rawEventsSerialized) {
  return Belt_Array.map(rawEventsSerialized, (function (rawEventSerialized) {
                var loggedValue;
                try {
                  var val = t_decode(JSON.parse(rawEventSerialized.loggedValueJson));
                  loggedValue = val.TAG === /* Ok */0 ? val._0 : /* Unembeddable */1;
                }
                catch (raw_obj){
                  var obj = Caml_js_exceptions.internalToOCamlException(raw_obj);
                  if (obj.RE_EXN_ID === Js_exn.$$Error) {
                    var m = obj._1.message;
                    if (m !== undefined) {
                      console.log("Caught a JS exception! Message: " + m);
                      loggedValue = /* Unembeddable */1;
                    } else {
                      loggedValue = /* Unembeddable */1;
                    }
                  } else {
                    throw obj;
                  }
                }
                return {
                        eventType: eventTypeFromString(rawEventSerialized.eventType),
                        information: rawEventSerialized.information,
                        sourcePosition: Caml_option.nullable_to_opt(rawEventSerialized.sourcePosition),
                        loggedValue: loggedValue
                      };
              }));
}

function information_decode(v) {
  return Decco.listFromJson(Decco.stringFromJson, v);
}

function io_input_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = Js_array.map(Js_json.classify, jsonArr$1);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "NoInput" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NoInput */0
                  };
          }
      case "OnlyInput" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* OnlyInput */1
                  };
          }
      case "Reentrant" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Reentrant */2
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function io_log_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var io_input = io_input_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "io_input"), null));
  if (io_input.TAG === /* Ok */0) {
    var io_output = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "io_output"), null));
    if (io_output.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                io_input: io_input._0,
                io_output: io_output._0
              }
            };
    }
    var e = io_output._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".io_output" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = io_input._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".io_input" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function event_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = Js_array.map(Js_json.classify, jsonArr$1);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "FunCall" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = fun_call_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* FunCall */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "SubScopeCall" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = sub_scope_call_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SubScopeCall */2,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "VarComputation" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = var_def_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* VarComputation */0,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function var_def_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var pos = Decco.optionFromJson(sourcePosition_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "pos"), null));
  if (pos.TAG === /* Ok */0) {
    var v$1 = Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null);
    var name = Decco.listFromJson(Decco.stringFromJson, v$1);
    if (name.TAG === /* Ok */0) {
      var io = io_log_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "io"), null));
      if (io.TAG === /* Ok */0) {
        var value = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
        if (value.TAG === /* Ok */0) {
          var fun_calls = Decco.optionFromJson((function (param) {
                  return Decco.listFromJson(fun_call_decode, param);
                }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "fun_calls"), null));
          if (fun_calls.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      pos: pos._0,
                      name: name._0,
                      io: io._0,
                      value: value._0,
                      fun_calls: fun_calls._0
                    }
                  };
          }
          var e = fun_calls._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".fun_calls" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = value._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".value" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = io._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".io" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = name._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".name" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = pos._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".pos" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function fun_call_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var v$1 = Belt_Option.getWithDefault(Js_dict.get(dict$1, "fun_name"), null);
  var fun_name = Decco.listFromJson(Decco.stringFromJson, v$1);
  if (fun_name.TAG === /* Ok */0) {
    var fun_inputs = Decco.listFromJson(var_def_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "fun_inputs"), null));
    if (fun_inputs.TAG === /* Ok */0) {
      var body = Decco.listFromJson(event_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "body"), null));
      if (body.TAG === /* Ok */0) {
        var output = var_def_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "output"), null));
        if (output.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    fun_name: fun_name._0,
                    fun_inputs: fun_inputs._0,
                    body: body._0,
                    output: output._0
                  }
                };
        }
        var e = output._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".output" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = body._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".body" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = fun_inputs._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".fun_inputs" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = fun_name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".fun_name" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function sub_scope_call_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var v$1 = Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null);
  var sname = Decco.listFromJson(Decco.stringFromJson, v$1);
  if (sname.TAG === /* Ok */0) {
    var inputs = Decco.listFromJson(var_def_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "inputs"), null));
    if (inputs.TAG === /* Ok */0) {
      var sbody = Decco.listFromJson(event_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "body"), null));
      if (sbody.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  sname: sname._0,
                  inputs: inputs._0,
                  sbody: sbody._0
                }
              };
      }
      var e = sbody._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: "." + ("body" + e.path),
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = inputs._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".inputs" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = sname._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: "." + ("name" + e$2.path),
            message: e$2.message,
            value: e$2.value
          }
        };
}

function deserializedEvents$1(eventsSerialized) {
  return Belt_Array.map(eventsSerialized, (function (eventSerialized) {
                try {
                  var val = event_decode(JSON.parse(eventSerialized.data));
                  if (val.TAG === /* Ok */0) {
                    return val._0;
                  }
                  var decodeError = val._0;
                  return Js_exn.raiseError("Error while decoding serialized events at " + decodeError.path + ": " + decodeError.message);
                }
                catch (raw_exn){
                  var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
                  if (exn.RE_EXN_ID === Js_exn.$$Error) {
                    var msg = exn._1.message;
                    if (msg !== undefined) {
                      return Js_exn.raiseError("Error while parsing event: " + msg);
                    } else {
                      return Js_exn.raiseError("Error while parsing event.");
                    }
                  }
                  throw exn;
                }
              }));
}

var Raw = {
  deserializedEvents: deserializedEvents
};

export {
  sourcePosition_decode ,
  LoggedValue ,
  Raw ,
  information_decode ,
  io_input_decode ,
  io_log_decode ,
  event_decode ,
  var_def_decode ,
  fun_call_decode ,
  sub_scope_call_decode ,
  deserializedEvents$1 as deserializedEvents,
}
/* No side effect */
